document.addEventListener("DOMContentLoaded", function() {
  const dropdownIcons = document.querySelectorAll(".navbar-nav-canvas .bi-plus");

  dropdownIcons.forEach(icon => {
    icon.addEventListener("click", function(event) {
      event.preventDefault();

      const dropdownMenu = icon.closest("li").querySelector("ul");

      if (!dropdownMenu) return;

      const isMenuOpen = dropdownMenu.classList.contains("show");

      if (isMenuOpen) {
        dropdownMenu.style.height = "0";
        dropdownMenu.classList.remove("show");
        // Change icon to bi-plus when the menu is closed
        icon.classList.remove("bi-dash");
        icon.classList.add("bi-plus");
      } else {
        dropdownMenu.style.height = dropdownMenu.scrollHeight + "px";
        dropdownMenu.classList.add("show");
        // Change icon to bi-dash when the menu is open
        icon.classList.remove("bi-plus");
        icon.classList.add("bi-dash");
      }
    });
  });

  document.querySelectorAll(".site-nav--has-dropdown ul").forEach(menu => {
    menu.addEventListener("transitionend", () => {
      if (menu.classList.contains("show")) {
        menu.style.height = "auto";
      }
    });
  });
});
